import * as Blockly from 'blockly';

class TilmiConstantProvider extends (Blockly as any).geras.ConstantProvider {
    constructor() {
        super();
        this.CORNER_RADIUS = 12;
        this.NOTCH_WIDTH = 26;
        this.NOTCH_HEIGHT = 8;
        this.MIN_BLOCK_WIDTH = 128;
        this.MIN_BLOCK_HEIGHT = 46;
        this.FIELD_TEXT_FONTSIZE = 13;
        this.FIELD_BORDER_RECT_RADIUS = 10;
        this.FIELD_BORDER_RECT_HEIGHT = 30;
        this.TAB_WIDTH = 14;
        this.TAB_HEIGHT = 24;
        this.TAB_OFFSET_FROM_TOP = 12;
    }
}

class TilmiRenderer extends (Blockly as any).geras.Renderer {
    makeConstants_() {
        return new TilmiConstantProvider();
    }
}

let registered = false;

export const registerTilmiRenderer = () => {
    if (registered) return;
    (Blockly as any).blockRendering.register('tilmiRenderer', TilmiRenderer);
    registered = true;
};

export default registerTilmiRenderer;
